import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "warning-dialog pa-5" }
const _hoisted_2 = { class: "d-flex align-center mb-3" }
const _hoisted_3 = { class: "text-body-1 text-grey-darken-3 mb-4" }
const _hoisted_4 = { class: "d-flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    transition: "dialog-top-transition",
    "max-width": "480px",
    "content-class": "warning-dialog-position",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "onClick:outside": _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            color: "error",
            size: "28",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-alert-circle", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-h6 text-error font-weight-bold" }, "Warning", -1))
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            color: "error",
            onClick: _ctx.onConfirm
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Continue", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onClick:outside"]))
}